import { AirdropPageTemplate } from "./template";
import { useAirdropPage } from "./logic";

export const AirdropPage = () : JSX.Element => {
    const props = useAirdropPage();

    return (
        <AirdropPageTemplate {...props}/>
    )
}